import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { TourStatiService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [TourStatiService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class TourStatiServiceModule {}
